import { render, staticRenderFns } from "./settled.vue?vue&type=template&id=f6ffd430&scoped=true"
import script from "./settled.vue?vue&type=script&lang=js"
export * from "./settled.vue?vue&type=script&lang=js"
import style0 from "./settled.vue?vue&type=style&index=0&id=f6ffd430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ffd430",
  null
  
)

export default component.exports